import {
  VictoryChart,
  VictoryLine,
  VictoryAxis,
  VictoryTooltip,
  VictoryVoronoiContainer,
  VictoryScatter,
} from "victory";

const FineGrainedChart = ({ chartData, xlabel, yLabel }) => {
  const yValues = chartData.map((d) => d.y);
  const yMin = Math.min(...yValues);
  const yMax = Math.max(...yValues);

  const interval = Math.ceil((yMax - yMin) / 5);
  const yTicks = Array.from({ length: 6 }, (_, i) => yMin + i * interval);

  return (
    <VictoryChart
      domainPadding={{ x: 20, y: 20 }}
      padding={{ bottom: 40, top: 40, left: 70, right: 20 }}
      containerComponent={<VictoryVoronoiContainer />}
    >
      <VictoryAxis
        label={xlabel}
        style={{
          axisLabel: { fill: "#104a5c", padding: 10, fontSize: 20 },
          tickLabels: {
            display: "none",
          },
          ticks: {
            stroke: "black",
            size: 3,
          },
        }}
      />

      <VictoryAxis
        dependentAxis
        label={yLabel}
        tickValues={yTicks}
        style={{
          // axis: { stroke: "white" },
          axisLabel: { padding: 40, fill: "#104a5c", fontSize: 20 },
          tickLabels: { fontSize: 10 },
          ticks: {
            stroke: "black",
            size: 3,
          },
        }}
      />

      <VictoryLine
        data={chartData}
        style={{
          data: { stroke: "#5651b7", strokeWidth: 2 },
        }}
      />

      <VictoryScatter
        data={chartData}
        size={3}
        style={{ data: { fill: "#5651b7" } }}
        labels={({ datum }) => `${xlabel}: ${datum.x}, ${yLabel}: ${datum.y}`}
        labelComponent={
          <VictoryTooltip style={{ fontSize: 10 }} constrainToVisibleArea />
        }
      />
    </VictoryChart>
  );
};

export default FineGrainedChart;
